import { UserInfo, BoardInfo } from '@mirohq/websdk-types'

const cachedInfo = <T>(key: string) => {
  return new Promise<T | undefined>((resolve) => {
    setTimeout(() => {
      const userInfo = sessionStorage.getItem(key)
      if (userInfo) {
        resolve(JSON.parse(userInfo))
      } else {
        resolve(undefined)
      }
    }, 1000)
  })
}

const miroUserInfo = async () => {
  const info = await miro.board.getUserInfo()
  sessionStorage.setItem('miroUserInfo', JSON.stringify(info))
  return info
}
const miroBoardInfo = async () => {
  const info = await miro.board.getInfo()
  sessionStorage.setItem('miroBoardInfo', JSON.stringify(info))
  return info
}

export const getMiroUserInfo = (): Promise<
  (UserInfo & { email?: string }) | undefined
> => {
  return Promise.race([miroUserInfo(), cachedInfo<UserInfo>('miroUserInfo')])
}

export const getMiroBoardInfo = (): Promise<BoardInfo | undefined> => {
  return Promise.race([miroBoardInfo(), cachedInfo<BoardInfo>('miroBoardInfo')])
}
